import React from 'react';
import Gamegos from '../assets/icons/gamegos.svg';
import Analysis from '../assets/icons/analysis.svg';
import ManorCafe from '../assets/game_logos/ManorCafe.png';
import AdventureBay from '../assets/game_logos/AdventureBay.png';
import Fashioncup from '../assets/game_logos/Fashioncup.png';
import Cookingtale from '../assets/game_logos/Cookingtale.png';
import CafelandMob from '../assets/game_logos/CafelandMobile.png';
import SolitaireStory from '../assets/game_logos/SolitaireStory.png';
import VideoJigSaw from '../assets/game_logos/VideoJigsaw.png';
import PuzzlePaint from '../assets/game_logos/PuzzlePaint.png';

import links from './links';
import socials from './socials';

export default [
  {
    title: 'Gamegos',
    image: Gamegos,
    links: [
      {
        title: 'Gamegos Home',
        link: links.gamegosHome.link,
        tags: [],
      },
      {
        title: 'Jira',
        link: links.jira.link,
        tags: [],
      },
      {
        title: 'Google Calendar',
        link: links.googleCalendar.link,
        tags: [],
      },
      {
        title: 'Device List',
        link: links.deviceListDoc.link,
        tags: [],
      },
      {
        title: links.analyticsLogs.title,
        link: links.analyticsLogs.link,
        tags: [],
      },
      {
        title: links.gameDeveloperLogs.title,
        link: links.gameDeveloperLogs.link,
        tags: [],
      },
      {
        title: 'API Specs',
        link: links.apiSpecsGamegos.link,
        tags: [],
      },
    ],
    socials: [
      socials.facebook({ link: 'https://www.facebook.com/gamegos' }),
      socials.twitter({ link: 'https://twitter.com/gamegos_co' }),
      socials.youtube({
        link: 'https://www.youtube.com/channel/UC-vsMjpHLBJTKw_aalXx1Qw/feed',
      }),
      socials.linkedin({
        link: 'https://www.linkedin.com/company/gamegos',
      }),
      socials.appStore({
        link: 'https://apps.apple.com/tr/developer/gamegos/id757773329',
      }),
      socials.playStore({
        link: 'https://play.google.com/store/apps/dev?id=5137364340371948270',
      }),
    ],
  },
  {
    title: 'Manor Cafe',
    image: ManorCafe,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.manorCafeManagement.link,
          },
          {
            title: 'Beta',
            link: links.manorCafeManagementBetaMaster.link,
          },
          {
            title: 'Level',
            link: links.manorCafeManagementBetaLevel.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.manorCafeSupport.link,
          },
          {
            title: 'Beta',
            link: links.manorCafeSupportBetaMaster.link,
          },
          {
            title: 'Level',
            link: links.manorCafeSupportBetaLevel.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.manorCafeCms.link,
          },
          {
            title: 'Beta',
            link: links.manorCafeCmsBeta.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        links: [{
          title: 'Dashboard (Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.manorCafeAnalytics.link,
            },
          ],
        },{
          title: 'Last 12 Months Dashboard(Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.manorCafeLast12MonthsAnalytics.link,
            },
          ],
        },
        {          
          title: (<p> Dashboard ( <span style={{ fontStyle: 'italic' }}>Old</span> )</p>),
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.manorCafePanelAnalytics.link,
            },
            {
              title: 'Beta',
              link: links.manorCafePanelAnalyticsBeta.link,
            },
          ],
        },
        ]
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.manorCafeSlackGame.link,
          },
          {
            title: 'Feed',
            link: links.manorCafeSlackFeed.link,
          },
        ],
      },
      {
        title: 'Google Sites',
        link: '',
        tags: [
          {
            title: 'Link',
            link: links.cafelandMobileGoogleSites.link,
          },
        ],
      },
      {
        title: 'Facebook',
        links: [
          {
            title: 'Dashboard',
            link: '',
            tags: [
              {
                title: 'Prod',
                link: links.manorCafeFacebookDashboard.link,
              },
            ],
          },
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.manorCafeAppStore.link }),
      socials.playStore({ link: links.manorCafePlayStore.link }),
      socials.zendesk({ link: links.manorCafeZendesk.link }),
      socials.facebook({ link: links.manorCafeFacebookPage.link }),
    ],
  },
  {
    title: 'Cafeland Mobile',
    image: CafelandMob,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cafelandMobileManagement.link,
          },
          {
            title: 'Beta',
            link: links.cafelandMobileManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cafelandMobileSupport.link,
          },
          {
            title: 'Beta',
            link: links.cafelandMobileSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cafelandMobileCms.link,
          },
          {
            title: 'Beta',
            link: links.cafelandMobileCmsBeta.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        links: [{
          title: 'Dashboard (Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.cafelandMobileAnalytics.link,
            },
          ],
        },{
          title: 'Last 12 Months Dashboard(Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.cafelandMobileLast12MonthsAnalytics.link,
            },
          ],
        },
        {
          title: (<p> Dashboard ( <span style={{ fontStyle: 'italic' }}>Old</span> )</p>),
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.cafelandMobilePanelAnalytics.link,
            },
            {
              title: 'Beta',
              link: links.cafelandMobilePanelAnalyticsBeta.link,
            },
          ],
        },
        ]
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.cafelandMobileSlackGame.link,
          },
          {
            title: 'Feed',
            link: links.cafelandMobileSlackFeed.link,
          },
        ],
      },
      {
        title: 'Google Sites',
        link: '',
        tags: [
          {
            title: 'Link',
            link: links.cafelandMobileGoogleSites.link,
          },
        ],
      },
      {
        title: 'Facebook',
        links: [
          {
            title: 'Dashboard',
            link: links.cafelandMobileFacebookDashboard.link,
            tags: [
              {
                title: 'Prod',
                link: links.cafelandMobileFacebookDashboard.link,
              },
            ],
          },
        ],
      },
    ],
    socials: [
      socials.appStore({
        link: links.cafelandMobileAppStore.link,
      }),
      socials.playStore({
        link: links.cafelandMobilePlayStore.link,
      }),
      socials.zendesk({
        link: links.cafelandMobileZendesk.link,
      }),
      socials.facebook({
        link: links.cafelandMobileFacebookPage.link,
      }),
    ],
  },
  {
    title: 'Adventure Bay',
    image: AdventureBay,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.adventureBayManagement.link,
          },
          {
            title: 'Beta',
            link: links.adventureBayManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.adventureBaySupport.link,
          },
          {
            title: 'Beta',
            link: links.adventureBaySupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.adventureBayCms.link,
          },
          {
            title: 'Beta',
            link: links.adventureBayCmsBeta.link,
          },
          {
            title: 'Quest-Beta',
            link: links.adventureBayCmsQuestBeta.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        links: [{
          title: 'Dashboard (Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.adventureBayAnalytics.link,
            },
          ],
        },{
          title: 'Last 12 Months Dashboard(Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.adventureBayLast12MonthsAnalytics.link,
            },
          ],
        },
        {
          title: (<p> Dashboard ( <span style={{ fontStyle: 'italic' }}>Old</span> )</p>),
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.adventureBayPanelAnalytics.link,
            },
            {
              title: 'Beta',
              link: links.adventureBayPanelAnalyticsBeta.link,
            },
          ],
        },
        ]
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.adventureBaySlackGame.link,
          },
          {
            title: 'Feed',
            link: links.adventureBaySlackFeed.link,
          },
        ],
      },
      {
        title: 'Google Sites',
        link: '',
        tags: [
          {
            title: 'Link',
            link: links.cafelandMobileGoogleSites.link,
          },
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.adventureBayAppStore.link }),
      socials.playStore({ link: links.adventureBayPlayStore.link }),
      socials.zendesk({ link: links.adventureBayZendesk.link }),
      socials.facebook({ link: links.adventureBayFacebookPage.link }),
    ],
  },
  {
    title: 'Cooking Tale',
    image: Cookingtale,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cookingTaleManagement.link,
          },
          {
            title: 'Beta',
            link: links.cookingTaleManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cookingTaleSupport.link,
          },
          {
            title: 'Beta',
            link: links.cookingTaleSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cookingTaleCms.link,
          },
          {
            title: 'Beta',
            link: links.cookingTaleCmsBeta.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.cookingTaleAnalytics.link,
          },
          {
            title: 'Beta',
            link: links.cookingTaleAnalyticsBeta.link,
          },
        ],
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.cookingTaleSlackGame.link,
          },
          {
            title: 'Feed',
            link: links.cookingTaleSlackFeed.link,
          },
        ],
      },
      {
        title: 'Facebook',
        links: [
          {
            title: 'Dashboard',
            link: '',
            tags: [
              {
                title: 'Prod',
                link: links.cookingTaleFacebookDashboard.link,
              },
              {
                title: 'Beta',
                link: links.cookingTaleFacebookDashboardBeta.link,
              },
            ],
          },
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.cookingTaleAppStore.link }),
      socials.playStore({ link: links.cookingTalePlayStore.link }),
      socials.freshdesk({ link: links.cookingTaleFreshdesk.link }),
      socials.facebook({ link: links.cookingTaleFacebookPage.link }),
    ],
  },
  {
    title: 'Solitaire Story',
    image: SolitaireStory,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.solitaireManagement.link,
          },
          {
            title: 'Beta',
            link: links.solitaireManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.solitaireSupport.link,
          },
          {
            title: 'Beta',
            link: links.solitaireSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.solitaireCms.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.solitaireAnalytics.link,
          },
          {
            title: 'Beta',
            link: links.solitaireAnalyticsBeta.link,
          },
        ],
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.solitaireStorySlackGame.link,
          },
          {
            title: 'Feed',
            link: links.solitaireStorySlackFeed.link,
          },
        ],
      },
      {
        title: 'Facebook',
        links: [
          {
            title: 'Dashboard',
            link: '',
            tags: [
              {
                title: 'Prod',
                link: links.solitaireFacebookDashboard.link,
              },
              {
                title: 'Beta',
                link: links.solitaireFacebookDashboardBeta.link,
              },
            ],
          },
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.solitaireAppStore.link }),
      socials.playStore({ link: links.solitairePlayStore.link }),
      socials.freshdesk({ link: links.solitaireFreshdesk.link }),
      socials.facebook({ link: links.solitaireFacebookPage.link }),
    ],
  },
  {
    title: 'Fashion Cup',
    image: Fashioncup,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.fashionCupManagement.link,
          },
          {
            title: 'Beta',
            link: links.fashionCupManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.fashionCupSupport.link,
          },
          {
            title: 'Beta',
            link: links.fashionCupSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'CMS',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.fashionCupCMS.link,
          },
          {
            title: 'Beta',
            link: links.fashionCupCMSBeta.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.fashionCupAnalytics.link,
          },
          {
            title: 'Beta',
            link: links.fashionCupAnalyticsBeta.link,
          },
        ],
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.fashionCupSlackGame.link,
          },
          {
            title: 'Feed',
            link: links.fashionCupSlackFeed.link,
          },
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.fashionCupAppStore.link }),
      socials.playStore({ link: links.fashionCupPlayStore.link }),
      socials.freshdesk({ link: links.fashionCupFreshdesk.link }),
      socials.facebook({ link: links.fashionCupFacebookPage.link }),
    ],
  },
  {
    title: 'Video Jigsaw',
    image: VideoJigSaw,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.videoJigsawPuzzleManagement.link,
          },
          {
            title: 'Beta',
            link: links.videoJigsawPuzzleManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.videoJigsawPuzzleSupport.link,
          },
          {
            title: 'Beta',
            link: links.videoJigsawPuzzleSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        links: [{
          title: 'Dashboard (Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.videoJigsawPuzzleAnalytics.link,
            },
          ],
        },{
          title: 'Last 12 Months Dashboard(Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.videoJigsawPuzzleLast12MonthsAnalytics.link,
            },
          ],
        },
        ]
      },
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.videoJigsawPuzzleSlackGame.link,
          },/* 
          {
            title: 'Feed',
            link: links.videoJigsawPuzzleSlackFeed.link,
          }, */
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.videoJigsawPuzzleAppStore.link }),
      socials.playStore({ link: links.videoJigsawPuzzlePlayStore.link }), /* 
      socials.freshdesk({ link: links.videoJigsawPuzzleFreshdesk.link }),*/
      socials.facebook({ link: links.videoJigsawPuzzleFacebookPage.link }), 
    ],
  },
  {
    title: 'Puzzle Paint',
    image: PuzzlePaint,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.puzzlePaintManagement.link,
          },
          {
            title: 'Beta',
            link: links.puzzlePaintManagementBetaMaster.link,
          },
        ],
      },
      {
        title: 'Support',
        link: '',
        tags: [
          {
            title: 'Prod',
            link: links.puzzlePaintSupport.link,
          },
          {
            title: 'Beta',
            link: links.puzzlePaintSupportBetaMaster.link,
          },
        ],
      },
      {
        title: 'Dashboard',
        links: [{
          title: 'Dashboard (Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.puzzlePaintAnalytics.link,
            },
          ],
        },{
          title: 'Last 12 Months Dashboard(Reports)',
          link: '',
          tags: [
            {
              title: 'Prod',
              link: links.puzzlePaintLast12MonthsAnalytics.link,
            },
          ],
        },
        ]
      },/* 
      {
        title: 'Catalog',
        link: '',
        tags: [
          {
            title: 'Catalog',
            link: links.puzzlePaintCatalog.link,
          },
        ],
      }, */
      {
        title: 'Slack',
        link: '',
        tags: [
          {
            title: 'Game',
            link: links.puzzlePaintSlackGame.link,
          },/* 
          {
            title: 'Feed',
            link: links.puzzlePaintSlackFeed.link,
          }, */
        ],
      },
    ],
    socials: [
      socials.appStore({ link: links.puzzlePaintAppStore.link }),
      socials.playStore({ link: links.puzzlePaintPlayStore.link }), 
      // socials.freshdesk({ link: links.puzzlePaintFreshdesk.link }),
      socials.facebook({ link: links.puzzlePaintFacebookPage.link }), 
    ],
  },
  {
    title: 'Analysis',
    image: Analysis,
    links: [
      {
        title: 'Activity Reports (Live)',
        link: '',
        tags: [
          {
            title: 'Cal',
            link: links.cafelandMobileActivityReport.link,
          },
          {
            title: 'Man',
            link: links.manorCafeActivityReport.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayActivityReport.link,
          },
          {
            title: 'Vjs',
            link: links.videoJigsawPuzzleActivityReport.link,
          },
          {
            title: 'Pzp',
            link: links.puzzlePaintActivityReport.link,
          },
        ],
      },
      {
        title: 'Cohort',
        links: [{
          title: 'Cohort Reports',
          link: '',
          tags: [
            {
              title: 'Cal',
              link: links.cafelandMobileCohortReport.link,
            },
            {
              title: 'Man',
              link: links.manorCafeCohortReport.link,
            },
            {
              title: 'Adv',
              link: links.adventureBayCohortReport.link,
            },
            {
              title: 'Vjs',
              link: links.videoJigsawPuzzleCohortReport.link,
            },
            {
              title: 'Pzp',
              link: links.puzzlePaintCohortReport.link,
            }
          ],
        },
        {
          title: 'Cohort Graphs',
          link: '',
          tags: [
            {
              title: 'Cal',
              link: links.cafelandMobileCohortGraph.link,
            },
            {
              title: 'Man',
              link: links.manorCafeCohortGraph.link,
            },
            {
              title: 'Adv',
              link: links.adventureBayCohortGraph.link,
            },
            {
              title: 'Vjs',
              link: links.videoJigsawPuzzleCohortGraph.link,
            },
            {
              title: 'Pzp',
              link: links.puzzlePaintCohortGraph.link,
            },
          ],
        }, {
          title: (
            <span className="card-link-multiline">AppsFlyer LTV<br />& Retention Reports</span>
          ),
          link: '',
          tags: [
            {
              title: 'Cal',
              link: links.cafelandMobileAppsFlyerLTVRetentionReports.link,
            },
            {
              title: 'Man',
              link: links.manorCafeAppsFlyerLTVRetentionReports.link,
            },
            {
              title: 'Adv',
              link: links.adventureBayAppsFlyerLTVRetentionReports.link,
            },
            {
              title: 'Vjs',
              link: links.videoJigsawPuzzleAppsFlyerLTVRetentionReports.link,
            },
            {
              title: 'Pzp',
              link: links.puzzlePaintAppsFlyerLTVRetentionReports.link,
            },
          ],
        },
        ]
      },{
        title: 'Monitoring Dashboard',
        link: '',
        tags: [
          {
            title: 'Cal',
            link: links.cafelandMobileMonitoringDashboard.link,
          },
          {
            title: 'Man',
            link: links.manorCafeMonitoringDashboard.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayMonitoringDashboard.link,
          },
          {
            title: 'Vjs',
            link: links.videoJigsawPuzzleMonitoringDashboard.link,
          },
          {
            title: 'Pzp',
            link: links.puzzlePaintMonitoringDashboard.link,
          },
        ],
      },
      {
        title: 'Marketing Dashboard',
        link: '',
        tags: [
          {
            title: 'Cal',
            link: links.cafelandMobileMarketingDashboard.link,
          },
          {
            title: 'Man',
            link: links.manorCafeMarketingDashboard.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayMarketingDashboard.link,
          },
          {
            title: 'Vjs',
            link: links.videoJigsawPuzzleMarketingDashboard.link,
          },
          {
            title: 'Pzp',
            link: links.puzzlePaintMarketingDashboard.link,
          },
        ],
      },
    ],
  },/*
  {
    title: 'Support',
    image: Support,
    links: [
      {
        title: 'Dashboard',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportDashboard.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportDashboard.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportDashboard.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportDashboard.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportDashboard.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportDashboard.link,
          },
        ],
      },
      {
        title: 'Users',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportUsers.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportUsers.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportUsers.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportUsers.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportUsers.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportUsers.link,
          },
        ],
      },
      {
        title: 'Logs',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportLogs.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportLogs.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportLogs.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportLogs.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportLogs.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportLogs.link,
          },
        ],
      },
      {
        title: 'Payment',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportPayment.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportPayment.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportPayment.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportPayment.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportPayment.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportPayment.link,
          },
        ],
      },
      {
        title: 'Compensation',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportCompensation.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportCompensation.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportCompensation.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportCompensation.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportCompensation.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportCompensation.link,
          },
        ],
      },
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeSupportManagement.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileSupportManagement.link,
          },
          {
            title: 'Adv',
            link: links.adventureBaySupportManagement.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleSupportManagement.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupSupportManagement.link,
          },
          {
            title: 'Sol',
            link: links.solitaireSupportManagement.link,
          },
        ],
      },
    ],
  },
  {
    title: 'Management',
    image: Management,
    links: [
      {
        title: 'Management',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeManagementManagement.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileManagementManagement.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayManagementManagement.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleManagementManagement.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupManagementManagement.link,
          },
          {
            title: 'Sol',
            link: links.solitaireManagementManagement.link,
          },
        ],
      },
      {
        title: 'Clan',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeManagementClan.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileManagementClan.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayManagementClan.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleManagementClan.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupManagementClan.link,
          },
          {
            title: 'Sol',
            link: links.solitaireManagementClan.link,
          },
        ],
      },
      {
        title: 'Definitions',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeManagementDefinitions.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileManagementDefinitions.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayManagementDefinitions.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleManagementDefinitions.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupManagementDefinitions.link,
          },
          {
            title: 'Sol',
            link: links.solitaireManagementDefinitions.link,
          },
        ],
      },
      {
        title: 'Others',
        link: '',
        tags: [
          {
            title: 'Man',
            link: links.manorCafeManagementOthers.link,
          },
          {
            title: 'Cal',
            link: links.cafelandMobileManagementOthers.link,
          },
          {
            title: 'Adv',
            link: links.adventureBayManagementOthers.link,
          },
          {
            title: 'Coo',
            link: links.cookingTaleManagementOthers.link,
          },
          {
            title: 'Fah',
            link: links.fashionCupManagementOthers.link,
          },
          {
            title: 'Sol',
            link: links.solitaireManagementOthers.link,
          },
        ],
      },
    ],
  },*/
];
